import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { auctionLimitPropertiesType } from '../../types';
import CreateButton from '../buttons/CreateButton';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import AuctionLimitCreateTab from './AuctionLimitCreateTab';

CreateAuctionLimitRow.propTypes = {
    auctionLimitProps: auctionLimitPropertiesType.isRequired,
};

function CreateAuctionLimitRow(props) {
    const {
        auctionLimitProps,
    } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-auction-limit-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}>
                <FontAwesomeIcon icon="plus" />&nbsp;{t('auction-limits.create-auction-limit')}
            </CreateButton>
            {isCreateVisible && (
                <AuctionLimitCreateTab
                    auctionLimitProps={auctionLimitProps}
                    hideHandler={() => setCreateVisible(false)}
                />
            )}
        </div>
    );
}

export default withPrivileges([Privileges.AUCTION_LIMIT_EDIT])(CreateAuctionLimitRow);
